import { render } from "./PUpgradeVIP.vue?vue&type=template&id=2744d3c6&scoped=true"
import script from "./PUpgradeVIP.vue?vue&type=script&lang=js"
export * from "./PUpgradeVIP.vue?vue&type=script&lang=js"

import "./PUpgradeVIP.vue?vue&type=style&index=0&id=2744d3c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2744d3c6"]])

export default __exports__